import React from 'react';
import styled from 'react-emotion';

import { classes as cn } from 'shared/styles';
import { BASE_COLOR as BC } from 'shared/constants/colors';

import { cx } from 'helpers';


const Button = styled('button')(props => ({
  color: props.disabled ? BC.moonGray : BC.darkGray,
  border: '2px solid',
  borderColor: BC.moonLightGray,
  transition: 'all 200ms',
  '&:hover': {
    cursor: props.disabled ? 'default' : 'pointer',
    background: props.disabled ? BC.white : BC.nearWhite,
    borderColor: props.disabled ? BC.moonLightGray : 'currentColor',
  },
}));


const StageContentBtn = ({ style = {}, className, ...props }) => (
  <Button
    className={cx(
      className,
      cn.animateFadeInSlow,
      cn.boxShadowRaisedButton,
      "pv1 ph2 f6 outline-0",
    )}
    style={{ ...style, }}
    {...props}
  >
    Ready
  </Button>
);



export {
  StageContentBtn,
}



// WEBPACK FOOTER //
// ./src/components/modules/common/StageContentBtn.js